<div class="content">
  <div class="title-xs">{{ icon() }}</div>
  <div class="title-xxs">{{ title() }}</div>
</div>
<div class="separator"></div>
